import React from 'react'
import { cn } from '@/lib/utils'

export type TileTone = 'brand' | 'violet' | 'success' | 'warning' | 'danger' | 'neutral' | 'ink'

export const TILE_TONE: Record<TileTone, string> = {
  brand: 'bg-brand/10 text-brand',
  violet: 'bg-violet/10 text-violet',
  success: 'bg-success/10 text-success',
  warning: 'bg-[#F5B400]/15 text-[#B97A00]',
  danger: 'bg-[#D33]/10 text-[#D33]',
  neutral: 'bg-canvas text-ink-3 dark:bg-surface-2',
  ink: 'bg-ink text-white dark:bg-surface-3 dark:text-ink',
}

const SIZE = {
  sm: 'size-8 rounded-[8px] [&>svg]:size-4',
  md: 'size-9 rounded-[10px] [&>svg]:size-[18px]',
  lg: 'size-10 rounded-[10px] [&>svg]:size-5',
  xl: 'size-[42px] rounded-[12px] [&>svg]:size-[22px]',
}

type Props = React.HTMLAttributes<HTMLSpanElement> & {
  tone?: TileTone
  size?: keyof typeof SIZE
  /** Use a custom colour (e.g. a card's own brand colour) instead of a tone. */
  color?: string
}

/**
 * Tinted icon square that leads rows, cards and dialog headers.
 * `color` tints from an arbitrary hex — used where content carries its own brand colour.
 */
const Tile = ({ tone = 'brand', size = 'md', color, className, style, children, ...props }: Props) => (
  <span
    className={cn(
      'inline-flex shrink-0 items-center justify-center',
      SIZE[size],
      !color && TILE_TONE[tone],
      className
    )}
    style={color ? { backgroundColor: `${color}1F`, color, ...style } : style}
    {...props}
  >
    {children}
  </span>
)

export default Tile
